import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { Address } from "../models/shared/address";
import { ClientSearchList } from "../models/shared/clientSearchList";

@Injectable({
  providedIn: "root",
})
export class CustomerAccountService {
  private commanBaseURL = environment.baseUrl + "/Common";
  private clientManagementBaseURL = environment.baseUrl + "/clientmanagement";
  constructor(private _http: HttpClient) {}

  getCustomerByNameAndAccountNumberFilter(
    customerAccountNumber = "",
    moduleName = "",
    salesOrderIdD365 = ""
  ): Observable<GenericResponseDto<ClientSearchList[]>> {
    return this._http.get<GenericResponseDto<ClientSearchList[]>>(
      this.clientManagementBaseURL +
        `/SearchClientByNameOrAccountNumber?nameAccounNumber=${encodeURIComponent(
          customerAccountNumber
        )}&moduleName=${moduleName}&salesOrderIdD365=${encodeURIComponent(
          salesOrderIdD365
        )}`
    );
  }

  getCustomerAddressByPartyNumber(
    partyNumber = "",
    accountNumber = ""
  ): Observable<GenericResponseDto<Address[]>> {
    return this._http.get<GenericResponseDto<Address[]>>(
      this.commanBaseURL +
        `/GetAddressesByPartyNumberAndAccountNumber?partyNumber=${partyNumber}&accountNumber=${accountNumber}`
    );
  }
}
